module.exports = "https://d1tntvpcrzvon2.cloudfront.net/vpassets/_next/static/images/MultipleAlbums-1c4c976fc579ee0ea49756c9cdf35a44.webp";